// Time zones for the company's clock (Settings → Company, sign-up and
// Getting started; the API's company_clock.py).

/** The device's own time zone, e.g. "America/Chicago" ('' if unknown). */
export const deviceZone = () => {
  try { return Intl.DateTimeFormat().resolvedOptions().timeZone || '' } catch { return '' }
}

/** "America/Chicago (GMT-6)" */
export const zoneLabel = (zone, now = new Date()) => {
  if (!zone) return ''
  let offset = ''
  try { offset = new Intl.DateTimeFormat('en-US', { timeZone: zone, timeZoneName: 'shortOffset' }).formatToParts(now).find((x) => x.type === 'timeZoneName')?.value || '' } catch { /* unknown here */ }
  return `${zone.replace(/_/g, ' ')}${offset && zone !== 'UTC' ? ` (${offset})` : ''}`
}

/** Every time zone the browser knows, as [name, label], with the ones given
    (the company's own, the device's) always in the list. */
export const zoneChoices = (...always) => {
  let names = []
  try { names = Intl.supportedValuesOf('timeZone') } catch { /* older browsers: just the ones below */ }
  const now = new Date()
  return [...new Set(['UTC', ...names, ...always.filter(Boolean)])].map((z) => [z, zoneLabel(z, now)])
}
